(() => {
  // ========= Config =========
  const REQUIRE_TERMS = true; // metti false se NON vuoi obbligare la spunta termini
  const REG_URL = 'https://latteriadelsole-shoponline.it/apps/wpdapp';

  // ========= Utils =========
  const DEBUG = false; // Enable debug logging
  const log = (...a) => DEBUG && console.log('[cart-guard]', ...a);
  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const isVisible = (el) => !!(el && el.offsetParent !== null);

  const SELECTORS_CHECKOUT = [
    'form[action*="/cart"] [name="checkout"]',
    'button[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.checkout-button',
    '.cart__checkout',
    '#Checkout',
    '#wcp-30-open'
  ];
  const SELECTORS_TERMS = ['#terms-cart', '#terms-drawer', '#terms'];
  const SELECTOR_INVOICE_TOGGLE = '[id^="fe-richiedifattura"]';
  const SELECTORS_FE_INPUTS = [
    'input[name="attributes[fe-codice-fiscale]"]',
    'input[name="attributes[fe-azienda]"]',
    'input[name="attributes[fe-tipo-estero]"]',
    'input[name="attributes[fe-piva]"]',
    'input[name="attributes[fe-tipo-cliente]"]',
    'input[name="attributes[fe-tipo-cliente-estero]"]'
  ];
  const CART_CONTAINERS = [
    'form[action*="/cart"]',
    '#CartDrawer',
    'cart-drawer',
    '[data-cart-drawer]'
  ];

  // ========= Stato cliente (da theme.liquid) =========
  function isLoggedIn() { return !!window.__CUSTOMER_LOGGED_IN; }

  // ========= Messaggi (fallback dinamico) =========
  const defaultError = 'Per procedere con il pagamento assicurati di inserire e verificare tutti i dati di fatturazione e di accettare termini e politica di reso.';
  function showErrorMsg(textHTML, beforeEl) {
    if (!beforeEl) return;
    let node = $('.msg-error-cb');
    if (!textHTML) { node && node.remove(); return; }
    if (!node) {
      node = document.createElement('div');
      node.className = 'msg-error-cb';
      beforeEl.parentNode.insertBefore(node, beforeEl);
    }
    node.innerHTML = textHTML;
  }

  // ========= Alert fissi (aggiunti nei template) =========
  function toggleLoginAlerts(show) {
    ['#fc-login-alert-cart', '#fc-login-alert-drawer'].forEach(sel => {
      $$(sel).forEach(el => {
        if (show) { el.style.display = 'block'; el.removeAttribute('hidden'); }
        else { el.style.display = 'none'; el.setAttribute('hidden',''); }
      });
    });
  }

  // ========= Bottoni checkout =========
  function getCheckoutButtons() {
    const found = new Set();
    SELECTORS_CHECKOUT.forEach(sel => $$(sel).forEach(btn => found.add(btn)));
    const arr = Array.from(found);
    log('checkout buttons:', arr);
    return arr;
  }
  function setCheckoutEnabled(enabled) {
    const buttons = getCheckoutButtons();
    buttons.forEach(btn => {
      if (enabled) {
        btn.removeAttribute('disabled'); btn.disabled = false;
        btn.setAttribute('aria-disabled','false');
        btn.style.opacity = ''; 
        btn.style.pointerEvents = '';
        btn.classList.remove('is-disabled','disabled');
        log('Enabling button:', btn);
      } else {
        btn.setAttribute('disabled','disabled'); btn.disabled = true;
        btn.setAttribute('aria-disabled','true');
        btn.style.opacity = '0.5'; 
        btn.style.pointerEvents = 'none';
        btn.classList.add('is-disabled');
        log('Disabling button:', btn);
      }
    });
    return buttons[0];
  }

  // ========= Condizioni =========
  function areTermsAccepted() {
    const boxes = SELECTORS_TERMS.flatMap(sel => $$(sel));
    if (!boxes.length) return !REQUIRE_TERMS;
    const visibleChecked = boxes.some(cb => cb.checked && isVisible(cb));
    return visibleChecked || boxes.some(cb => cb.checked);
  }
  function computeInvoiceOkFromFields() {
    const blocks = $$('.cart__fe-block');
    if (!blocks.length) return false;
    
    const checkBlock = (root, index) => {
      const itRadio = $('input[name="attributes[fe-tipo-estero]"][value="italia"]', root);
      const estComp = $('input[name="attributes[fe-tipo-cliente-estero]"][value="company"]', root);
      const cf      = $('input[name="attributes[fe-codice-fiscale]"]', root);
      const azienda = $('input[name="attributes[fe-azienda]"]', root);
      const piva    = $('input[name="attributes[fe-piva]"]', root);
      
      const cfVal = (cf?.value || '').trim();
      const azVal = (azienda?.value || '').trim();
      const piVal = (piva?.value || '').trim();
      
      log(`Block ${index}:`, {
        itRadioChecked: itRadio?.checked,
        estCompChecked: estComp?.checked,
        cfVal: cfVal,
        azVal: azVal,
        piVal: piVal
      });
      
      if (itRadio && itRadio.checked) {
        const valid = cfVal.length >= 2;
        log(`Block ${index} (Italia): CF="${cfVal}" -> ${valid}`);
        return valid;
      }
      if (estComp && estComp.checked) {
        const valid = azVal.length >= 2 && piVal.length >= 8;
        log(`Block ${index} (Estero Company): Azienda="${azVal}", PIVA="${piVal}" -> ${valid}`);
        return valid;
      }
      const valid = cfVal.length >= 2;
      log(`Block ${index} (Default): CF="${cfVal}" -> ${valid}`);
      return valid;
    };
    
    const result = blocks.some((b, i) => checkBlock(b, i));
    log('computeInvoiceOkFromFields result:', result);
    return result;
  }
  function isInvoiceOk() {
    const toggles = $$(SELECTOR_INVOICE_TOGGLE);
    log('Invoice toggles found:', toggles.length);
    
    if (toggles.length) {
      toggles.forEach((t, i) => {
        log(`Toggle ${i}: data-chk="${t.getAttribute('data-chk')}"`);
      });
      const result = toggles.some(t => t.getAttribute('data-chk') === '1');
      log('Invoice OK from toggles:', result);
      return result;
    }
    
    log('No toggles found, checking fields...');
    const blocks = $$('.cart__fe-block');
    log('FE blocks found:', blocks.length);
    
    if (!blocks.length) {
      log('No .cart__fe-block found - invoice form not present, returning TRUE (allow checkout)');
      return true; // Changed from false to true - if no invoice form, allow checkout
    }
    
    const result = computeInvoiceOkFromFields();
    log('Invoice OK from fields:', result);
    return result;
  }
  function isForeignCompanySelected() {
    return $$('.cart__fe-block').some(root => {
      const est  = $('input[name="attributes[fe-tipo-estero]"][value="estero"]', root);
      const comp = $('input[name="attributes[fe-tipo-cliente-estero]"][value="company"]', root);
      return !!(est && est.checked && comp && comp.checked);
    });
  }

  // ========= Compat integrazioni =========
  function runShiftElectronicInvoiceCheck() {
    try {
      if (typeof window.shiftElectronicInvoice === 'function') {
        const inst = window.shiftElectronicInvoice();
        if (inst && typeof inst.checkRequiredInput === 'function') inst.checkRequiredInput();
      } else if (window.shiftElectronicInvoice?.checkRequiredInput) {
        window.shiftElectronicInvoice.checkRequiredInput();
      }
    } catch(e) {}
  }

  function evaluate() {
    runShiftElectronicInvoiceCheck();

    const terms = areTermsAccepted();
    const invOk = isInvoiceOk();
    const needsLogin = isForeignCompanySelected() && !isLoggedIn();
    const ok = terms && invOk && !needsLogin;

    log('evaluate -> terms:', terms, 'invOk:', invOk, 'needsLogin:', needsLogin, 'final ok:', ok);

    const anchor = setCheckoutEnabled(ok);

    if (needsLogin) {
      toggleLoginAlerts(true);
      showErrorMsg('', anchor); // niente messaggio generico
    } else {
      toggleLoginAlerts(false);
      if (!ok) showErrorMsg(defaultError, anchor);
      else showErrorMsg('', anchor);
    }

    log('evaluate ->', { terms, invOk, needsLogin, ok });
  }

  // ========= Event binding & observers =========
  function bindEventsOnce(root = document) {
    SELECTORS_TERMS.forEach(sel => {
      $$(sel, root).forEach(cb => {
        if (!cb.__boundChange) { cb.addEventListener('change', evaluate); cb.__boundChange = true; }
      });
    });
    SELECTORS_FE_INPUTS.forEach(sel => {
      $$(sel, root).forEach(inp => {
        if (!inp.__boundInput) {
          inp.addEventListener('input', evaluate);
          inp.addEventListener('keyup', evaluate);
          inp.addEventListener('change', evaluate);
          inp.__boundInput = true;
        }
      });
    });
  }
  function observeCartContainers() {
    CART_CONTAINERS.forEach(sel => {
      const el = $(sel); if (!el || el.__observing) return;
      const obs = new MutationObserver(() => { bindEventsOnce(el); setTimeout(evaluate, 50); });
      obs.observe(el, { childList: true, subtree: true }); el.__observing = true;
    });
  }

  // ========= Bootstrap =========
  window.cartGuardEvaluate = evaluate;
  const style = document.createElement('style');
  style.textContent = `
    .msg-error-cb { margin: 8px 0 12px; font-size: .92rem; line-height: 1.3; color: var(--color-error, #d72c0d); }
    .msg-error-cb a { text-decoration: underline; }
    .is-disabled { pointer-events: none; }
  `;
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      bindEventsOnce(document); observeCartContainers(); setCheckoutEnabled(false); evaluate();
      let n=0; const iv=setInterval(()=>{evaluate(); if(++n>=10) clearInterval(iv)},300);
    });
  } else {
    bindEventsOnce(document); observeCartContainers(); setCheckoutEnabled(false); evaluate();
    let n=0; const iv=setInterval(()=>{evaluate(); if(++n>=10) clearInterval(iv)},300);
  }
})();
